import { render } from "./transferWarehouse.vue?vue&type=template&id=0b00397a"
import script from "./transferWarehouse.vue?vue&type=script&lang=js"
export * from "./transferWarehouse.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__